import SearchInput from './SearchInput';

export { type SearchInputProps } from './SearchInput';
export default SearchInput;
